import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import {
  getWarehouseProcessStageAppServiceStage,
} from "../../../services/WarehouseStage/WarehouseStage";

const WHProcessStageListViewAppServiceAddModal = ({
  wHProcessStageListViewAppServiceAddModalVisible,
  setWHProcessStageListViewAppServiceAddModalVisible,
  selectedItemValue,
}) => {
  const wareHouseGarmentProcessStageId = selectedItemValue?.id;


  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [appServiceValue, setAppServiceValue] = useState({});

  const ViewAppServices = (wareHouseGarmentProcessStageId) => {
    getWarehouseProcessStageAppServiceStage(wareHouseGarmentProcessStageId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setAppServiceValue(res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    ViewAppServices(wareHouseGarmentProcessStageId);
  }, [wareHouseGarmentProcessStageId]);

  const handleModalClose = () => {
    setWHProcessStageListViewAppServiceAddModalVisible(false);
    setAppServiceValue({})
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={wHProcessStageListViewAppServiceAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!wHProcessStageListViewAppServiceAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                
              ></div>

              <p className=" text-4xl text-primary-50 font-semibold">
                APP SERVICES
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="grid mt-1 mx-3 justify-content-center">
                <div className="mx-3">
                  <div
                    className=" surface-0 border-round-md"
                    style={{
                      backgroundImage:
                        "radial-gradient(circle at left top, #1752AA, #2B70D7)",
                    }}
                  >
                    <p className="text-white text-center text-xl font-semibold capitalize p-3">
                      {appServiceValue?.stageAppServices ? (
                        Object.values(appServiceValue?.stageAppServices).join(
                          ", "
                        )
                      ) : (
                        <div>
                          <p className="text-xl font-medium">
                            No App Services Found
                          </p>
                        </div>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WHProcessStageListViewAppServiceAddModal;
